import axios from '@/plugins/http/axios.js';
import config from "@/shared/components/menu_user_company/config/menu_user_company_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getMenuUserCompany: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/empresas/companybyid/${idEmpresa}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      }
    });
  }
};
